import { render, staticRenderFns } from "./myBankCard.vue?vue&type=template&id=d4bf2bea&"
import script from "./myBankCard.vue?vue&type=script&lang=js&"
export * from "./myBankCard.vue?vue&type=script&lang=js&"
import style0 from "./myBankCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports